import React from 'react';
import SEOHead from '../components/SEOHead';
import { getOrganizationSchema } from '../utils/seoSchemas';
import { Mail } from 'lucide-react';

const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;

const Contact = () => (
  <>
    <SEOHead
      title="Contact WorldCup Fan Planner"
      description="Contact WorldCup Fan Planner for feedback, corrections, or partnership questions about 2026 FIFA World Cup travel and fan planning."
      schema={getOrganizationSchema()}
    />
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">Contact</h1>
      <p className="text-gray-600 dark:text-gray-400 mb-8">
        For corrections to match or venue data, press or partnership inquiries, or general feedback, reach out using the options below.
      </p>
      <div className="p-6 rounded-xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700">
        {contactEmail ? (
          <a
            href={`mailto:${contactEmail}?subject=WorldCup%20Fan%20Planner%20inquiry`}
            className="inline-flex items-center gap-2 text-lg font-medium text-amber-600 dark:text-amber-400 hover:underline"
          >
            <Mail className="h-5 w-5" />
            {contactEmail}
          </a>
        ) : (
          <p className="text-gray-700 dark:text-gray-300">
            Set <code className="text-sm bg-gray-100 dark:bg-gray-900 px-1 rounded">REACT_APP_CONTACT_EMAIL</code> in your environment to show a public contact address. Until then, use your site host’s support channel if applicable.
          </p>
        )}
      </div>
    </div>
  </>
);

export default Contact;
